import { render, staticRenderFns } from "./DataDictionaryList.vue?vue&type=template&id=37105f46&"
import script from "./DataDictionaryList.vue?vue&type=script&lang=js&"
export * from "./DataDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionaryList.vue?vue&type=style&index=0&id=37105f46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports